import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LeftTruncatePipe } from '../../pipes/left-truncate.pipe';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { BlankValueDashComponent } from '../blank-value-dash/blank-value-dash.component';
import { PatientAlternateNamesComponent } from '../patient-alternate-names/patient-alternate-names.component';

class MinimalPatient {
  id: number;
  mrn: string;
  dob: Date;
  fullName: string;
  // only the payloads that carry the patient's alternate names have these
  alternateFirstNames?: string[];
  alternateLastNames?: string[];
}

@Component({
    selector: 'app-patient-name',
    templateUrl: './patient-name.component.html',
    imports: [RouterLinkActive, RouterLink, BlankValueDashComponent, DatePipe, LeftTruncatePipe,
              PatientAlternateNamesComponent]
})
export class PatientNameComponent implements OnInit {
  readonly INFINITY = Infinity;

  @Input() patient: MinimalPatient;
  @Input() sourcePatient: MinimalPatient;
  @Input() showAlternateNames = true;
  // the patient name a claim was matched on, when it was not the name the patient goes by
  @Input() matchedName: string;
  @Input() canViewPatient = false;
  @Input() mrnDisplayCharacters = Infinity;

  visiblePatient: MinimalPatient;

  constructor() {}

  ngOnInit() {
    if (this.sourcePatient) {
      this.visiblePatient = this.sourcePatient;
    } else {
      this.visiblePatient = this.patient;
    }
  }
}
